import Vue from "vue";
import axios from "axios";
import { provide, inject } from "@vue/composition-api";

const actions = {

    fetchClassifier(id) {
        return new Promise(function(resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/admin/classificator/" + id)
                .then(function(response) {
                    resolve(response.data);
                })
                .catch(function(ex) {
                    reject(ex);
                });
        });
    },

    deleteClassifier(id) {
        return new Promise(function(resolve, reject) {
            axios
                .delete(Vue.config.url_prefix + "/api/admin/classificator/" + id)
                .then(function(response) {
                    resolve(response.data);
                })
                .catch(function(ex) {
                    reject(ex);
                });
        });
    },

    fetchHelpClassifiers(params) {

        return new Promise(function(resolve, reject) {
            axios
                .get(Vue.config.url_prefix + "/api/admin/help/", { params: params })
                .then(function(response) {
                    resolve(response.data);
                })
                .catch(function(ex) {
                    reject(ex);
                });
        });
    },

    saveHelpClassifier(data) {
        return new Promise(function(resolve, reject) {
            axios
                .post(Vue.config.url_prefix + "/api/admin/help/", data)
                .then(function(response) {
                    resolve(response.data);
                })
                .catch(function(ex) {
                    reject(ex);
                });
        });
    }
};

export const key = Symbol("ClassifierModule");

export const provideClassifier = () =>
    provide(key, {
        ...actions
    });

export default () => inject(key);
